<template>
    <div v-if="selectedHeat != ''" id="h-editor">
        <div class="editor f-column">
            <div class="header f-row">
                <div><span class="start-pos">{{ Entrant.startPos }}</span> &nbsp; <span class="bib">{{ Entrant.bib }}</span></div>
                <div class="try">
                    {{$t('text.tryShort')}}{{cResultId + 1}}
                </div>
            </div>
            <div class="name-label">{{ Entrant.name }} ({{Entrant.classShort}})</div>            
            <div class="f-row input-field">
                <div style="width:75%" class="f-column">
                    <div v-if="SelectedHeat.windMeasurement">
                        <a href="javascript:;" :class="{focus: focused === 'wind'}" @keydown="onKeyDown" @focus="focusField('wind')" @click="focusField('wind')"><div class="wind"></div><div class="f-grow field" :class="{neg: isWindNegativ, pos: !isWindNegativ && windString != '', blink: IsResultCurrent}">{{ windString }}</div></a>
                    </div>
                    <div>
                        <a href="javascript:;" :class="{focus: focused === 'result'}" @keydown="onKeyDown" @focus="focusField('result')" @click="focusField('result')"><div class="ruler"></div><div class="f-grow field" :class="{blink: IsResultCurrent}">{{ formatResult(resultString) }}</div></a>
                    </div>
                </div>
                <div class="rank">
                    {{getRank}}
                </div>
            </div>
            <div @click="enterValue" class="f-row input">
                <div class="f-column" :class="{disabled: MaxLengthReached}">
                    <div class="f-row">
                        <div>1</div>
                        <div>2</div>
                        <div>3</div>
                    </div>
                    <div class="f-row">
                        <div>4</div>
                        <div>5</div>
                        <div>6</div>
                    </div>   
                    <div class="f-row">
                        <div>7</div>
                        <div>8</div>
                        <div>9</div> 
                    </div>         
                    <div class="f-row">  
                        <div :class="{disabled: focused == 'wind'}">X</div>
                        <div>0</div>
                        <div v-if="isWindNegativ && focused == 'wind'">+</div> 
                        <div v-else>-</div> 
                    </div>
                </div>
                <div class="button">                        
                    <div class="del" @click="backSpace"></div> 
                    <div class="button return" @click="confirmValue"></div>   
                    <div :class="{disabled: focused == 'wind'}">r</div>    
                </div>
            </div>     
            <div class="footer f-row input" v-if="IsResultCurrent && NextEntrant!=null">
                <div v-if="!!NextEntrant">{{$t('text.next')}}: <span class="start-pos">{{ NextEntrant.startPos }}</span> &nbsp; <span class="bib">{{ NextEntrant.bib }}</span> &nbsp; {{$t('text.tryShort')}}{{ getNextResultId+1 }}<br>{{ NextEntrant.name }} ({{Entrant.classShort}})</div>
                <div class='button arrow-buttons next' @click="nextEntrant(false)"></div>
            </div>
            <div class="footer f-row" v-if="!IsResultCurrent || NextEntrant==null">
                <button @click="abortEdit">{{$t('text.abort')}}</button>
                <button @click="setNewCurrent">{{$t('text.setCurrent')}}</button>
                <button @click="saveEdit">{{$t('text.save')}}</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMut from '../store/mutations/navigation';

export default {
    name: "HorizontalEdit",
    data: function(){
        return {
            result: 0,
            resultString: "",
            wind: 0,
            windString: '',
            windNeg: false,
            cEntrantId: 0,
            nextEntrantId: 0,
            cResultId: 0,
            nextResultId: 0,
            focused: 'wind',
            request: (data) => {                
                if(data.id === this.SelectedHeat.id) {
                    this.setNextEntrant(data);
                }
            }
        }
    },
    methods:{
        ...mapActions([glAct.SENDRESULT,
            glAct.SENDHEATGROUP,
            glAct.SENDCURRENTCURSOR]),
        ...mapMutations([
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,
            glMut.SETRESULTIDS,
            glMut.UNSETHEATDATA,
            glMut.RANKUPDATE,
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT]),
        nextEntrant(skipRaise, doNotCalc){   
            if(this.Entrant.results[this.cResultId].dirty && !skipRaise){
                this.confirmValue();  
            }
            if(this.ConnectionState === 1) {
                this.SENDCURRENTCURSOR({eId: this.SelectedHeat.entries[this.nextEntrantId].id, cResultId: this.nextResultId, cHeightId: null});                
                if(!skipRaise) {
                    this.SETRESULTIDS({
                        eId: this.nextEntrantId,
                        rId: this.nextResultId, 
                        src: 'cc',
                        nEId: null,
                        nRId: null,
                    });
                }
            }  
            else{
                if(!doNotCalc){
                    const dropInfoOld = this.getEntryDropPosition(this.cEntrantId, this.cResultId);

                    if(dropInfoOld.entryDropedStartPosition === dropInfoOld.dropCount){ //check if current Entry was last in droped Startlist
                        this.nextResultId++;
                        if(this.nextResultId === 6){
                            this.nextResultId=0;
                        }
                    }

                    if(!skipRaise) {
                        this.nextEntrantId = this.NEntryId;
                    }
                }
                this.SENDCURRENTCURSOR({eId: this.SelectedHeat.entries[this.nextEntrantId].id, cResultId: this.nextResultId, cHeightId: null});                
                this.cEntrantId = this.nextEntrantId;
                this.cResultId = this.nextResultId;

                const dropInfoCurrent = this.getEntryDropPosition(this.cEntrantId, this.cResultId);


                let postNextStartPosition = dropInfoCurrent.entryDropedStartPosition+1;
                let postNextRId = this.nextResultId;
                if(postNextStartPosition === dropInfoCurrent.dropCount+1){
                    postNextRId++;
                    if(postNextRId === 6){
                        postNextRId=0;
                    }
                    postNextStartPosition = 1;
                }

                const dropInfNext = this.getEntryDropPosition(undefined, postNextRId, postNextStartPosition);
                const nextEId = dropInfNext.entryStartPosition;

                this.SETRESULTIDS({
                    eId: this.nextEntrantId,
                    rId: this.nextResultId, 
                    src: 'cc',
                    nEId: nextEId,
                    nRId: postNextRId,
                });
            }


            this.refreshFields();
        },
        getEntryDropPosition(eId, rId, byPosition){
            let nextDrop = 0;
            let dropCount = 0;

            this.SelectedHeat.entries.forEach((e, index) => {                
                for(var i=rId; i>=0; i--){
                    if(e.dropStartlist[i] !== undefined && i >= nextDrop) { //exists in dropList and is latest Drop
                        if(nextDrop != i) //newer drop found
                            dropCount = 0;
                        nextDrop = i;
                        dropCount++;
                        return;
                    }
                }
            });
            const bib = eId != undefined ? this.SelectedHeat.entries[eId].dropStartlist[nextDrop] : byPosition;

            let entryPosition = this.SelectedHeat.entries.findIndex(e => e.dropStartlist[nextDrop] === bib);
            entryPosition = entryPosition === -1 ? this.SelectedHeat.entries.findIndex(e => e.dropStartlist[0] === bib) : entryPosition;

            return {entryStartPosition: entryPosition, dropCount: dropCount, dropIndex: nextDrop, entryDropedStartPosition: this.SelectedHeat.entries[entryPosition].dropStartlist[nextDrop]};
        },
        setNextEntrant(data){
            var i = this.selectedHeat.entries.findIndex(x => x.id == data.nextEntry);
            this.nextEntrantId = i;
            this.nextResultId=data.nextTry;
            
            this.SETRESULTIDS({
                eId: null,
                rId: null, 
                src: 'cc',
                nEId: this.nextEntrantId,
                nRId: this.nextResultId,
            });
        },
        changeTry(){
            this.SETRESULTIDS({eId: this.cEntrantId ,rId: this.cResultId, src: 'other'});
        },
        abortEdit(){            
            this.SETRESULTIDS({eId: this.CEntryId ,rId: this.CResultId, src: 'other'});
        },
        setNewCurrent(){
            this.nextEntrantId = this.SelectedEntrantId;
            this.nextResultId = this.SelectedResultId;
            this.nextEntrant(false, true);
        },
        saveEdit(){
            this.confirmValue(null);
            this.SETRESULTIDS({eId: this.CEntryId ,rId: this.CResultId, src: 'other'});
        },
        refreshFields(){
            this.Entrant.results[this.cResultId].dirty = true;
            if(this.SelectedHeat.windMeasurement) {
                this.focusField('wind');
                this.wind = this.Entrant.results[this.cResultId].wind;
                if(this.wind<0){
                    this.windNeg = true;
                    this.wind *= -1;
                }
                else{
                    this.windNeg = false;
                }
                this.windString = this.wind === null ? '' : this.wind.toFixed(1);
            }
            else{
                this.focusField('result');
            }

            this.result = this.Entrant.results[this.cResultId].value;
            this.resultString =  this.result === 0 ? '' : this.result.toFixed(2);
        },
        enterValue(event, directInput){
            let val = '';
            if(directInput){
                val = event;
            }
            else{
                val = event.srcElement.innerText
            }
            this.Entrant.results[this.cResultId].dirty = true;
            this.Entrant.results[this.cResultId].highjumpTries = '';
            if(val.length == 1 && this.focused != null && !this.MaxLengthReached){
                if(['-', '+'].includes(val) && this.focused === 'wind'){
                    this.windNeg = !this.windNeg;
                }
                if(['X', '-', 'r'].includes(val) && this.focused === 'result'){
                    this.resultString = val;
                    
                    switch(val) {
                        case 'X':
                            this.result = -1;
                            break;
                        case '-':
                            this.result = -2;
                            this.Entrant.results[this.cResultId].highjumpTries = '';
                            break;
                        case 'r':
                            this.result = -2;
                            this.Entrant.results[this.cResultId].highjumpTries = 'r';
                            break;
                    }
                }
                else if(!['X', '-', 'r'].includes(this.resultString) && !['X', '-', 'r', '+'].includes(val)){
                    if(this.focused === 'result') {
                        this.result = (this.result * 1000 + parseInt(val)) / 100;
                        this.resultString = this.result.toFixed(2);
                    }
                    else if(this.focused === 'wind'){
                        this.wind = (this.wind * 100 + parseInt(val)) / 10;
                        this.windString = this.wind.toFixed(1);

                    }
                }
            }            
        },
        backSpace (event){
            this.Entrant.results[this.cResultId].dirty = true;
            if(this.focused === 'result') {
                this.result = Number.parseInt((this.result * 10), 10) / 100;
                if(this.result > 0) {
                    this.resultString = this.result.toFixed(2);
                }
                else{
                    this.resultString = '';
                    this.result = 0;
                }
            }
            else if(this.focused === 'wind'){
                if(this.wind){
                    this.wind = Number.parseInt(this.wind, 10) / 10;
                    this.windString = this.wind.toFixed(1);
                }
                else{
                    this.windString = '';
                    this.wind = null;
                }
            }
            
            if(event) event.stopPropagation();
            
        },
        confirmValue(event){
            if(this.focused === 'wind' && this.result === 0) {
                this.focusField('result');
                return;
            }
            if(this.Entrant.results[this.cResultId].dirty){
                this.Entrant.results[this.cResultId].value = this.result;
                if(this.Entrant.results[this.cResultId].value === 0){
                    this.Entrant.results[this.cResultId].wind = null;
                    this.wind = null;
                    this.windString = '';
                }
                else{
                    this.Entrant.results[this.cResultId].wind = this.windNeg ? this.wind * -1 : this.wind;
                }
                if(!this.IsResultCurrent) {
                    this.SENDHEATGROUP();
                }
                else{
                    this.SENDRESULT({result: this.Entrant.results[this.cResultId], eId: this.Entrant.id});
                }
            }
            this.Entrant.results[this.cResultId].dirty = false;
            if(event) event.stopPropagation();
        },
        onKeyDown(event){
            //console.log(event);
            switch (event.keyCode) {
                case 8: //backSpace
                    this.backSpace(event);
                    break;
                case 9://TAB
                    if(this.SelectedHeat.windMeasurement)
                    {
                        switch (this.focused) {
                            case 'wind':
                                this.focusField('result');
                                break;
                            case 'result':
                                this.focusField('wind');
                                break;
                            default:
                                this.focusField('result');
                        }
                    }
                    break;
                case 13: //enter
                    if(this.focused === 'result'){
                        this.confirmValue(event);
                    }
                    else{
                        this.focusField('result');
                    }
                    break;
                case 109: // minus
                case 107: // plus
                case 189: // dash
                    this.enterValue('-', true);
                    break;
                case 82: //r and R
                    this.enterValue('r', true);
                    break;
                case 88: //x and X
                    this.enterValue('X', true);
                    break;
                default:
                    if(event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode >= 48 && event.keyCode <= 57) //number from 0-9
                        this.enterValue(event.key, true);
            }
            if(event) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        formatResult(result){
            switch(result) {
                    case "-2.00":
                        if(this.Entrant.results[this.cResultId].highjumpTries !== 'r') {
                            return '-';
                        }
                        return 'r';
                        break;
                    case "-1.00":
                        return 'X';
                        break;
                    default:
                        return result;
                }
        },
        focusField(field){
            this.focused = field;
        },
        setStateNavi(){
            if(this.HeatState < 2){
                this.HIDENAVPOINT([5]);
                this.SHOWNAVPOINT([4]);
            }
            else if(this.HeatState === 2){
                this.HIDENAVPOINT([4]);
                this.SHOWNAVPOINT([5]);
            }
            else if(this.HeatState === 3){                
                this.UNSETHEATDATA();
                this.$router.push('/competition/events/');
            }
        },
    },
    computed:{
        ...mapGetters(['ConnectionState','SelectedHeat', 'HeatState', 'SelectedEntrantId', 'SelectedResultId', 'IsResultCurrent', 'CEntryId', 'CResultId', 'NEntryId', 'NResultId']),
        selectedHeat(){
            return this.SelectedHeat;
        },
        Entrant(){
            return this.selectedHeat.entries[this.cEntrantId];
        },
        NextEntrant(){
            return this.selectedHeat.entries[this.nextEntrantId];
        },
        submitImage(){
            return require('../../assets/img/enter.png');
        },
        getNextResultId(){
            return this.nextResultId
        },
        getRank(){
            return this.Entrant.rank ? `${this.Entrant.rank}.` : (this.Entrant.withoutEval ? `${this.$i18n.t('text.noRankingShort')}` : '') ;
        },
        isWindNegativ(){
            return this.windNeg;
        },
        MaxLengthReached(){
            if(this.focused === 'wind' && this.wind && this.wind > 1 && this.wind.toString().length === 3) {
                return true;
            }
            else if(this.focused === 'result' && this.result && this.result.toFixed(2).length === 5){
                return true;
            }
            return false;
        }
    },
    created(){
        var RegisterMethods = () => {
            this.REGISTERHUB({
                name: "ReceiveHeatGroupRankUpdate",
                method: this.request
            });
        }

        if(this.ConnectionState !== 0){
            RegisterMethods();
        }

        this.$store.subscribe((mutation, state) => {
            if(mutation.type == glMut.SETCONNECTION && state.glModule.connection != ""){
                RegisterMethods();
            }
        });
    },
    watch: {
        SelectedEntrantId(){
            this.cEntrantId = this.SelectedEntrantId;
            this.refreshFields();
        },
        SelectedResultId(){
            this.cResultId = this.SelectedResultId;
            this.refreshFields();
        },
        HeatState() {
            this.setStateNavi();
        },
    },
    mounted(){
        this.setStateNavi();
        this.cEntrantId = this.SelectedEntrantId;        
        this.cResultId = this.SelectedResultId;
        this.nextEntrantId = this.SelectedEntrantId;
        this.nextResultId = this.SelectedResultId;
        this.nextEntrant(true);
    },
    beforeDestroy(){        
        this.UNREGISTERHUB({
                name: "ReceiveHeatGroupRankUpdate",
                method: this.request
        });
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";


    .editor {        
        padding: 10px;
        background-color: $form-bg-color;
        margin-top: 10px;
        padding-top: 5px;
    }

    .header {
        font-size:30px;
        font-weight: bold;
        

        .try {
            width: 25%;
            margin-left: auto;
            text-decoration: none;
            display:flex;

            select {
                color: $font-light-color;
                height: 100%;
                width:100%;
                background-color: $prim_shadow_color;
                font-size: 20px;
                padding-left: 33%;
            }
        }
    }

    
    .start-pos::before, .bib::before {
        font: normal normal normal 30px "Material Design Icons";
    } 

    .footer {
        .start-pos::before, .bib::before {
            font: normal normal normal 14px "Material Design Icons";
        }        
    }

    .start-pos::before {
        content:"\F04BC";
    }

    .bib::before {
        content:"\F0631";
    }

    .name-label {
        font-size:14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .footer {
        padding-top:33px;
        font-size:14px;
        font-weight: bold;
        color: $sec_bg_color;
        > div:first-of-type {
            padding-top: 14px;
        }
    }

    .results {
        min-height: 32px;
        padding-top:10px;
    }

    .result {
        border: solid 1px $sec_color_dark;
        min-width: 70px;
        padding: 0 5px;
        padding-top: 2px;
        text-align: center;
        margin: 0px 5px;
        font-weight: bold;
    }

    .active {
        background-color:$prim_bg_color;
    }

    .input-field {
        padding-top:10px;

        a.focus {
            outline: none;
            

            .field::after {
                content:"|"; 
                position: relative;
                margin-right: -11px;
                top: -4px;
                
                animation: blink 1.3s linear infinite;
            }
        }
        .field {
            height:$height_mid;
            border: solid 1px $sec_color_dark;
            cursor: pointer;
            text-align: center;
            line-height: $height_mid;
            color:$seltec_color;
            font-size: 40px;
            font-weight: bold;
            justify-content: center;
        }

        .wind, .ruler {
            position: relative;
        }

        .wind::before, .ruler::before, .start-pos::before, .bib::before {
            font: normal normal normal 24px/1 "Material Design Icons";
            color: $sec_bg_color;
            font-size:30px;
            line-height:$height_mid;
            position: absolute;
            padding-left: 10px;  
            height:$height_mid;

        }

        .wind::before {          
            content:"\F0240";
        }

        .ruler::before {
            content:"\F046D";
        }

        .wind + .neg::before {
            content: "-";
        }

        .wind + .pos::before {
            content: "+";
        }

        @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 1; }
            50.01% { opacity: 0; }
            100% { opacity: 0; }
        }

        a{
            text-decoration: none;
        }        

        a.focus .blink {
            animation: blink-bg 2s infinite alternate;
        }        

        @keyframes blink-bg {
            0% {
                background-color: $blink-dark-light;
            }

            100% {
                background-color: $blink-dark-dark;
            }  
        }

        .rank {
            background-color:$seltec_color; 
            color: $font-dark-color; 
            width:25%; 
            font-size: $height_default;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    a:visited .field {
        border-color: $prim_success_color;
    }
    .input {
         padding-bottom: 10px;
        
        > div {
            width:25%;
        }

        > div:first-of-type {
            width: 75%;
        }
        .f-row, .button {
            justify-content: center;
            div {
                border: solid 1px #818181;
                cursor: pointer;
                min-height: $height_high;
                min-width: $height_high;
                font-weight: bold;
                background-color: #000;
                box-sizing: border-box;
                display: flex;
                flex-grow: 1;
                justify-content: center;
                align-items: center;
            }
        }

        .disabled {
            opacity: 0.5;
        }

        .return {
            max-height: 2*$height_high;
        }

        .return::after {
            font: normal normal normal 24px/1 "Material Design Icons";
            content: "\F0311";
            color: $font-light-color;
            line-height: ($height_high * 2);
        } 

        .del::before {
            vertical-align: -15%;
            font: normal normal normal 24px/1 "Material Design Icons";
            content:"\F0B5C";
        }
    }

    .footer .button {
        justify-content: center;
        border: solid 1px #818181;
        cursor: pointer;
        min-width: $height_high;
        font-weight: bold;
        background-color: #000;
        box-sizing: border-box;
        display: flex;
        flex-grow: 1;
        justify-content: center;
        align-items: center;
    }

    .arrow-buttons {
        min-height: $height_high;
        line-height: $height_high;
        height: $height_high;
        color: $font-light-color;
    }  
    
    .next {        
        margin-left: auto;
    }

    .next::after {
        font: normal normal normal 24px/1 "Material Design Icons";
        content:"\F09C2";
    }   

    button {
        height: $height_default;
        background-color: $prim_bg_color;
        border: solid 2px $seltec_color;
        color: $font-light-color;
        font-weight: bold;
        cursor: pointer;
        padding: 0px 15px;
    }

    button:nth-child(2) {
        margin: 0 auto;
    }

    @media screen and (max-width: 801px) {                
        .editor {
            margin:0 auto;
        }
    }

    @media screen and (max-height: 680px) {  
        .button, .buttons div {
            min-height: $height_mid;
            line-height: $height_mid;
        }         

        .footer {
            padding-top:10px;
        }
    }

</style>